export const quadflex_hoodie = {
  msrp: 64.99,
  infoLink: 'https://www.teamtriton.com/quadflex-hoodie.html',
  items: [
    {
      number: 'QF099',
      hasModel: false,
    },
    {
      number: 'QF100',
      hasModel: false,
    },
    {
      number: 'QF101',
      hasModel: false,
    },
    {
      number: 'QF102',
      hasModel: false,
    },
    {
      number: 'QF103',
      hasModel: false,
    },
    {
      number: 'QF104',
      hasModel: false,
    },
    {
      number: 'QF105',
      hasModel: false,
    },
    {
      number: 'QF106',
      hasModel: false,
    },
    {
      number: 'QF107',
      hasModel: false,
    },
    {
      number: 'QF108',
      hasModel: false,
    },
  ],
};
